var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    {
      attrs: {
        title: _vm.$t("common.report-text", {
          text: _vm.$t("lbl_general_ledger")
        })
      }
    },
    [
      _c(
        "a-row",
        { attrs: { type: "flex", gutter: [16, 16] } },
        [
          _c(
            "a-col",
            { attrs: { span: 24 } },
            [
              _c(
                "a-form",
                _vm._b(
                  { attrs: { "label-align": "left", form: _vm.form } },
                  "a-form",
                  _vm.formItemLayout,
                  false
                ),
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: _vm.$t(_vm.formRules.accountNumber.label)
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRules.accountNumber.decorator,
                              expression: "formRules.accountNumber.decorator"
                            }
                          ],
                          attrs: {
                            name: _vm.formRules.accountNumber.name,
                            placeholder: _vm.$t(
                              _vm.formRules.accountNumber.placeholder
                            ),
                            showSearch: true,
                            "filter-option": false,
                            loading: _vm.loading.accountNumber,
                            allowClear: true,
                            "label-in-value": "",
                            "option-label-prop": "label"
                          },
                          on: { search: _vm.searchData }
                        },
                        _vm._l(_vm.dataAccountNumber, function(data, index) {
                          return _c(
                            "a-select-option",
                            {
                              key: index,
                              attrs: { value: data.id, label: data.label }
                            },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(" " + _vm._s(data.label) + " ")
                                  ]),
                                  _vm._v(" " + _vm._s(data.label) + " ")
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: { label: _vm.$t(_vm.formRules.periodFrom.label) }
                    },
                    [
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: _vm.formRules.periodFrom.decorator,
                            expression: "formRules.periodFrom.decorator"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          placeholder: _vm.$t(
                            _vm.formRules.periodFrom.placeholder
                          ),
                          format: _vm.DEFAULT_DATE_FORMAT
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t(_vm.formRules.periodTo.label) } },
                    [
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: _vm.formRules.periodTo.decorator,
                            expression: "formRules.periodTo.decorator"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          placeholder: _vm.$t(
                            _vm.formRules.periodTo.placeholder
                          ),
                          format: _vm.DEFAULT_DATE_FORMAT
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-space",
                    [
                      _c(
                        "a-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.onclickButton("reset", "All")
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_reset")) + " ")]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary", loading: _vm.loading.find },
                          on: {
                            click: function($event) {
                              return _vm.onclickButton("find", "No")
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_find")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { span: 24 } },
            [
              _c("a-table", {
                attrs: {
                  size: "small",
                  "row-key": "id",
                  "data-source": _vm.dataSource,
                  columns: _vm.columnsTable,
                  scroll: { x: "calc(1300px + 50%)" },
                  loading: _vm.loading.find,
                  "row-class-name": function(_record, index) {
                    return index % 2 ? "bg-white" : "bg-gray-light"
                  },
                  pagination: {
                    total: _vm.dataSource.length,
                    showSizeChanger: true,
                    showTotal: function(total) {
                      return _vm.$t("lbl_total_items", { total: total })
                    }
                  }
                },
                on: { change: _vm.onTableChange }
              })
            ],
            1
          ),
          _c(
            "a-col",
            { staticClass: "mt-3", attrs: { span: 24, align: "end" } },
            [
              _c(
                "a-button",
                {
                  staticClass: "mr-2",
                  attrs: { type: "primary", loading: _vm.loading.download },
                  on: {
                    click: function($event) {
                      return _vm.onclickButton("download", "All")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("lbl_download")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }